<script setup>
import { useRouter } from "vue-router";

const router = useRouter();
const props = defineProps({
  nonLinkTagName: {
    type: String,
    default: "div",
  },
  href: {
    type: String,
    default: undefined,
  },
  onClick: {
    type: Function,
    default: undefined,
  },
});

const handleClick = (event) => {
  // console.debug("clicking", props);
  if (props.onClick) {
    props.onClick(event);
    if (event.defaultPrevented) {
      // console.debug("default prevented", props);
      return;
    }
  }

  if (props.href) {
    if (props.href.startsWith("http")) {
      // external link, let the browser redirect
      // console.debug("letting default happen", props);
    } else {
      // internal link, use the router instead
      // console.debug("default prevented, using router", props);
      event.preventDefault();
      router.push(props.href);
    }
  }
};
</script>
<template>
  <component
    :is="href ? 'a' : props.nonLinkTagName"
    @click="handleClick"
    :href="href"
    is-a-link="yes sir"
  >
    <slot></slot>
  </component>
</template>
